import React from "react";
import { toast } from "react-toastify";

import SvgIcon from "../../Icon/SvgIcon.jsx";

/**
 * Общие настройки для уведомлений всех типов
 * Настройки [тут]{@link(https://fkhadra.github.io/react-toastify/introduction)}
 */
const options = {
  position: "bottom-left",
  theme: "colored",
  autoClose: 10000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
};

/**
 * Уведомление для отображения ошибки
 *
 * @param {String|JSX.Element} message
 */
export const notifyError = message => {
  toast.error(message, {
    ...options,
    // eslint-disable-next-line react/display-name
    icon: () => <SvgIcon name="alertError" color="#fff" />,
  });
};

/**
 * Уведомление для отображения предупреждения
 *
 * @param {String|JSX.Element} message
 */
export const notifyWarn = message => {
  toast.warn(message, {
    ...options,
    // eslint-disable-next-line react/display-name
    icon: () => <SvgIcon name="alertWarn" color="#fff" />,
  });
};

/**
 * Уведомление на случай если действие выполнено успешно
 *
 * @param {String|JSX.Element} message
 */
export const notifySuccess = message => {
  toast.success(message, {
    ...options,
    // eslint-disable-next-line react/display-name
    icon: () => <SvgIcon name="alertSuccess" color="#fff" />,
  });
};
